/**
 * @generated SignedSource<<1d6f70c3e1e023a365792c5218aba5f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchJiraFilter_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultJiraFilter";
  readonly description: string;
  readonly iconUrl: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchJiraFilter_AtlassianSearchPage";
};
export type searchJiraFilter_AtlassianSearchPage$key = {
  readonly " $data"?: searchJiraFilter_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchJiraFilter_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchJiraFilter_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    }
  ],
  "type": "SearchResultJiraFilter"
};

(node as any).hash = "16cb9379c0ec44d660de2e7ef7b7d063";

export default node;
